// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-data-table>.v-data-table__wrapper .v-data-table__mobile-table-row{margin:10px;border:1px solid #ededed;display:block}.hidden{color:transparent}.text-filter{color:#b64351!important;font-size:12px}#messages-panel{z-index:203!important}", ""]);
// Exports
module.exports = exports;
